import Svg, { Circle } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import type { StyleProp, ViewStyle } from 'react-native';

export const ContextualMenuButton = withDefaultIconProps(
  {
    height: 22,
    width: 22,
    color: '#595B5E',
  },
  ({ color, style, dotSize = 5.333, ...rest }: { color?: string; dotSize?: number; style?: StyleProp<ViewStyle> }) => (
    <Svg {...rest} viewBox="0 0 22 22" style={style}>
      <Circle cx={11} cy={3} r={dotSize / 2} fill={color} />
      <Circle cx={11} cy={11} r={dotSize / 2} fill={color} />
      <Circle cx={11} cy={19} r={dotSize / 2} fill={color} />
    </Svg>
  ),
);
